import React from 'react';
import fr from 'facet-rest';
import useHomeContext from 'Context/HomeContext';
import { redirectToMaintenance } from 'Helpers/Redirect';
import { Authentication } from 'Views/Authentication';
import { pick } from 'Helpers/Affordances';
import ExistingPasswordReset from './ExistingPasswordReset';

export const PasswordResetPicker = () => {
  const { homeResource } = useHomeContext();

  const passwordResetRelationship = homeResource.withRelationship(fr.relationships.resetPassword.name, (rel) => rel, () => null);

  // Bail if you don't have the passwordReset relationship
  React.useEffect(() => {
    if (!passwordResetRelationship) {
      redirectToMaintenance();
    }
  }, [passwordResetRelationship]);

  return pick(homeResource, {
    [fr.relationships.loginVisualUpdate.name]: (<Authentication url={passwordResetRelationship.link('related').url()} />),
    [fr.relationships.loginNoAuthSession.name]: (<Authentication url={passwordResetRelationship.link('related').url()} />),
  }, <ExistingPasswordReset />);
};
